/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useAuth } from "../../contexts/authContext";
import { useTranslation } from "react-i18next";

import {
  Form,
  Input,
  Select,
  Tabs,
  Button,
  Row,
  Col,
  Spin,
  DatePicker,
} from "antd";
import { LoadingOutlined } from "@ant-design/icons";

import { commonUtil } from "../../utils";
import { getProfile, updateProfile } from "../../api";
import dayjs from "dayjs";
import { isEmailValid, removeVietnameseTonesEmail } from "../../utils/common";

const EditProfile = () => {
  const { t } = useTranslation(["common", "notification"]);
  const auth = useAuth();
  const [form] = Form.useForm();
  const [loaded, setLoaded] = useState<boolean>(false);

  useEffect(() => {
    const fetchData = async () => {
      const userProfile = await getUserProfile();
      if (userProfile) {
        form.setFieldsValue({
          firstName: userProfile.first_name || "",
          lastName: userProfile.last_name || "",
          email: userProfile.email || "",
          phone: userProfile.phone || "",
          gender:
            typeof userProfile.gender === "number" ? userProfile.gender : 0,
          birthday: userProfile.birthday ? dayjs(userProfile.birthday) : null,
        });
      }
    };
    setTimeout(() => {
      setLoaded(true);
    }, 500);
    fetchData();
  }, []);

  const getUserProfile = async () => {
    const resProfile = await getProfile();
    if (resProfile.status === "success") {
      return resProfile.data;
    }
    return null;
  };

  const saveProfile = async () => {
    const res = await updateProfile({
      gender: form.getFieldValue("gender"),
      firstName: form.getFieldValue("firstName"),
      lastName: form.getFieldValue("lastName"),
      email: form.getFieldValue("email"),
      phone: form.getFieldValue("phone"),
      birthday: form.getFieldValue("birthday")
        ? form.getFieldValue("birthday").format("YYYYMMDD")
        : "",
    });

    if (res.status === "success") {
      commonUtil.showMessage(
        "success",
        t("notification:Cập nhật thông tin thành công")
      );
      // Cập nhật authContext
      const userProfile = await getUserProfile();
      if (userProfile) {
        auth.login(userProfile);
      }
    } else {
      commonUtil.showMessage("error", res.message);
    }
  };

  if (!loaded) {
    return (
      <Spin
        size="large"
        indicator={<LoadingOutlined spin />}
        style={{ width: "100%" }}
      />
    );
  }

  return (
    <Tabs
      defaultActiveKey="1"
      style={{
        borderRadius: "8px",
        padding: "0 16px 16px 16px",
        marginBottom: "16px",
        backgroundColor: "white",
      }}
      className="shadow"
    >
      <Tabs.TabPane tab={t("common:Thông tin cá nhân")} key="1">
        <Form form={form} layout="vertical" onFinish={saveProfile}>
          <Row>
            <Col lg={12} xs={24} style={{ padding: "0 5px" }}>
              <Form.Item
                label={t("common:Họ")}
                name="lastName"
                rules={[
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value) {
                        return Promise.reject(
                          new Error(t("notification:Vui lòng nhập thông tin"))
                        );
                      } else if (value?.trim()?.length > 30) {
                        return Promise.reject(
                          new Error(
                            t("notification:Họ không được dài quá 30 kí tự")
                          )
                        );
                      }
                      return Promise.resolve();
                    },
                  }),
                ]}
              >
                <Input placeholder={t("common:Họ")} />
              </Form.Item>
            </Col>
            <Col lg={12} xs={24} style={{ padding: "0 5px" }}>
              <Form.Item
                label={t("common:Tên")}
                name="firstName"
                rules={[
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value) {
                        return Promise.reject(
                          new Error(t("notification:Vui lòng nhập thông tin"))
                        );
                      } else if (value?.trim()?.length > 30) {
                        return Promise.reject(
                          new Error(
                            t("notification:Tên không được dài quá 30 kí tự")
                          )
                        );
                      }
                      return Promise.resolve();
                    },
                  }),
                ]}
              >
                <Input placeholder={t("common:Tên")} />
              </Form.Item>
            </Col>
            <Col lg={12} xs={24} style={{ padding: "0 5px" }}>
              <Form.Item
                name="email"
                label={t("Email")}
                rules={[
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || isEmailValid(value.trim()))
                        return Promise.resolve();
                      // if (!isEmailValid(value)) {
                      //   return Promise.reject(
                      //     new Error(
                      //       t("notification:Email không đúng định dạng")
                      //     )
                      //   );
                      // }
                      return Promise.reject(
                        new Error(t("notification:Email không đúng định dạng"))
                      );
                      // return Promise.resolve();
                    },
                  }),
                ]}
              >
                <Input
                  placeholder="Email"
                  onBlur={(e) => {
                    form.setFieldValue(
                      "email",
                      removeVietnameseTonesEmail(e.target.value)
                    );
                  }}
                />
              </Form.Item>
            </Col>
            <Col lg={12} xs={24} style={{ padding: "0 5px" }}>
              <Form.Item name="phone" label={t("common:Số điện thoại")}>
                <Input placeholder={t("common:Số điện thoại")} />
              </Form.Item>
            </Col>
            <Col lg={12} xs={24} style={{ padding: "0 5px" }}>
              <Form.Item name="gender" label={t("common:Giới tính")}>
                <Select>
                  <Select.Option value={1}>{t("common:Nam")}</Select.Option>
                  <Select.Option value={2}>{t("common:Nữ")}</Select.Option>
                  <Select.Option value={0}>{t("common:Khác")}</Select.Option>
                </Select>
              </Form.Item>
            </Col>
            <Col lg={12} xs={24} style={{ padding: "0 5px" }}>
              <Form.Item
                name="birthday"
                label={t("common:Ngày sinh")}
                rules={[
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value) {
                        return Promise.reject(
                          new Error(t("notification:Vui lòng nhập thông tin"))
                        );
                      }
                      return Promise.resolve();
                    },
                  }),
                ]}
              >
                <DatePicker
                  style={{ width: "100%" }}
                  placeholder={t("common:Ngày sinh")}
                  format="DD/MM/YYYY"
                  disabledDate={(date) => dayjs().subtract(12, "years") < date}
                />
              </Form.Item>
            </Col>
          </Row>
          <div style={{ textAlign: "center" }}>
            <Button
              type="primary"
              style={{ fontWeight: 600 }}
              htmlType="submit"
            >
              {t("common:Lưu lại")}
            </Button>
          </div>
        </Form>
      </Tabs.TabPane>
    </Tabs>
  );
};

export default EditProfile;
